<template>
	<div v-if="!isFetching">
		<div class="columns">
			<div class="column">
				<div class="select is-multiple">
					<select v-model="transfer" multiple size="12">
						<option
							v-for="dashboard in transferable"
							:key="dashboard.id"
							:value="dashboard"
						>
							{{ dashboard.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="column is-2">
				<button
					class="button is-fullwidth is-dailycare is-outlined transfer-layout"
					:disabled="!transfer.length"
					@click.prevent="transferDashboards"
				>
					<dc-icon
						icon="chevron-double-right"
						library="fas"
						no-margin
					/>
				</button>
			</div>
			<div class="column">
				<div
					class="box dashboard-holder"
					:class="{ 'empty-state': !myFields.length }"
				>
					<draggable
						:list="myValue"
						:group="{ draggable: '.key-feature' }"
						@end="end"
					>
						<div
							v-for="(_name, index) in myFields"
							:key="index"
							class="box key-feature"
						>
							<div class="columns">
								<div class="column is-narrow">
									<span class="dragger">
										<dc-icon icon="bars" no-margin />
									</span>
								</div>
								<div class="column">
									{{ layoutName(index) }}
								</div>
								<div class="column is-narrow">
									<span
										class="delete-item"
										@click.prevent="removeFeature(index)"
									>
										<dc-icon icon="times" no-margin />
									</span>
								</div>
							</div>
						</div>
					</draggable>
					<div v-if="!myFields.length">
						<p><strong>Add a layout to this user</strong></p>
						<p>From the options to the left</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import fieldArrayMixin from "@lab/utils/fieldArrayMixin";
import draggable from "vuedraggable";
import { sortBy } from "lodash";

export default {
	components: { draggable },
	mixins: [fieldMixin, fieldArrayMixin],
	props: {
		label: {
			type: String,
			default: () => "Dashboards"
		}
	},
	data() {
		return {
			transfer: []
		};
	},
	computed: {
		dashboards() {
			return sortBy(this.$store.getters.dashboardsList, ["name"]);
		},
		isFetching() {
			return this.$store.getters.dashboardsIsFetching;
		},
		selected() {
			return this.value;
		},
		transferable() {
			return this.dashboards.filter(
				(dashboard) =>
					!this.value.map((d) => d.id).includes(dashboard.id)
			);
		},
		myValue: {
			get() {
				return this.myFields;
			},
			set() {
				// Updating is handled via 'end'
			}
		}
	},
	created() {
		this.fetchDashboards();
	},
	methods: {
		fetchDashboards() {
			this.$store.dispatch("dashboardsLoad");
		},
		layoutName(index) {
			const { name } = this.value[index];
			return name;
		},
		transferDashboards() {
			this.transfer.forEach((dashboard) => {
				this.fieldPush(dashboard);
			});
		},
		removeFeature(index) {
			this.fieldRemove(index);
		},
		end(change) {
			this.fieldMove(change.oldIndex, change.newIndex);
		}
	}
};
</script>

<style lang="scss" scoped>
.dashboard-holder {
	padding: 0.5rem;
	min-height: 435px;

	&.empty-state {
		border: 2px dashed rgba(10, 10, 10, 0.2);
		padding: 50% 0;
		text-align: center;
	}
}

.key-feature {
	padding: 1rem;
	margin-bottom: 0.5rem;
}

div.select {
	display: block;

	select {
		width: 100%;
		min-height: 435px;
	}
}

.button.transfer-layout {
	margin-top: 200px;
}

.delete-item {
	cursor: pointer;
}
.dragger {
	cursor: grab;

	.sortable-chosen &,
	.sortable-ghost & {
		cursor: grabbing;
	}
}
</style>
